import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Loader } from "../../components/customLoader";
import errorHandler from "../../utils/errorHandler";
import { capitalize, displayPermissions } from "../../utils/helpers";
import ApiService from "../../services/categoryManagementApi";

const { subAdminServcie } = ApiService;

const ViewSubAdminManagement = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await subAdminServcie.getById({ id: id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userData();
  }, []);
  
  return (
    <Dialog maxWidth="md" fullWidth={true} open={show} onClose={onHide}>
      <DialogTitle as="h2">Subadmin Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant="subtitle1">Full Name</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.name)}{" "}
              </DialogContentText>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="subtitle1">Email</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.email)}{" "}
              </DialogContentText>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="subtitle1">Status</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.status == "1" ? "Active" : "Deactive"}
                {/* {capitalize(data?.status)}{" "} */}
              </DialogContentText>
            </Grid>
            {
                    data?.role === "subAdmin" && 
                    <Grid item xs={12} md={12}>
               
                    <Typography variant="subtitle1">Permissions</Typography>
                    <DialogContentText sx={{ marginBlockStart: "1em" }}>
                      {displayPermissions(data?.permission)}
                      {/* {capitalize(data?.status)}{" "} */}
                    </DialogContentText>
                  </Grid>
                }
          
          </Grid>
          <DialogActions>
            <Button variant="outlined" onClick={() => onHide()} type="submit">
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewSubAdminManagement;
